import { ImplementationParams } from '@/backend/access/implementation/types';

export class Implementation {
  id: string;
  title: string;
  description: string;
  orgId: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;

  constructor(params: ImplementationParams) {
    this.id = params.id;
    this.title = params.title;
    this.description = params.description;
    this.orgId = params.orgId;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
  }
}
